import React, { useEffect } from 'react';

import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { isSmartLinkDrag } from '@atlaskit/editor-smart-link-draggable';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

import { isDraggingBodyClass } from './isDraggingBodyCSSClass.ts';

const isSmartLinkDraggingClass = 'is-smart-link-dragging';

type TreeMonitorProps = {
	setIsDraggingItem?: (arg: boolean) => void;
	/* Note: changes to `itemItem` during a drag operation is not supported */
	itemType?: string;
};

export function TreeMonitor({
	setIsDraggingItem,
	itemType = 'tree-item',
}: TreeMonitorProps): React.JSX.Element {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	useEffect(() => {
		return monitorForElements({
			canMonitor: ({ source }) =>
				source.data.type === itemType || isSmartLinkDrag(source.data.type),
			onGenerateDragPreview: ({ source }) => {
				setIsDraggingItem?.(true);
				document.body.classList.add(isDraggingBodyClass);
				if (isSmartLinkDrag(source.data.type)) {
					document.body.classList.add(isSmartLinkDraggingClass);
				}
			},
			onDrop: () => {
				setIsDraggingItem?.(false);
				document.body.classList.remove(isDraggingBodyClass);
				document.body.classList.remove(isSmartLinkDraggingClass);
			},
		});
	}, [setIsDraggingItem, itemType]);

	useEffect(function mount() {
		return function unmount() {
			document.body.classList.remove(isDraggingBodyClass);
			document.body.classList.remove(isSmartLinkDraggingClass);
		};
	}, []);

	return <div data-testid="tree-monitor" data-vc="tree-monitor" {...ssrPlaceholderIdProp} />;
}
